export const ICON_MAP = {
  'tachometer-alt': 'gaikuang',
  'shopping-bag': 'shangpin',
  'clipboard-list': 'jiaoyi',
  'store-alt': 'jingxiaoshang',
  'gem1': 'huiyuan',
  'brush': 'moban',
  'gift': 'yingxiao',
  'file-invoice-dollar': 'caiwu',
  'chart-bar': 'tongji',
  'sitemap': 'zhandian',
  'yingyong-01': 'yingyong',
  'cog': 'shezhi'
}

export const SALES_STATUS = [
  { title: '前台可銷售', value: 'onsale' },
  { title: '前台不顯示', value: 'offline_sale' },
  { title: '前台僅顯示', value: 'only_show' },
  { title: '不可銷售', value: 'instock' }
]

export const DISTRIBUTION_TYPE = [
  { title: '全部', value: '' },
  { title: '普通快遞', value: 'logistics' },
  { title: '同城配', value: 'dada' },
  { title: '客戶自取', value: 'ziti' }
]

export const ORDER_STATUS = [
  { title: '全部', value: '' },
  { title: '待付款', value: 'notpay' },
  { title: '待出貨', value: 'notship' },
  { title: '待收貨', value: 'shipping' },
  { title: '待退款', value: 'cancelapply' },
  { title: '待自取', value: 'ziti' },
  { title: '已取消', value: 'cancel' },
  { title: '已完成', value: 'finish' },
  { title: '待接單', value: 'dada_0' },
  { title: '待外送員接單', value: 'dada_1' },
  { title: '待取貨', value: 'dada_2' },
  { title: '外送員到店', value: 'dada_100' },
  { title: '配送中', value: 'dada_3' },
  { title: '未收貨', value: 'dada_9' }
]

export const ORDER_B2C_STATUS = [
  { title: '全部', value: '' },
  { title: '待付款', value: 'notpay' },
  { title: '待出貨', value: 'notship' },
  { title: '待收貨', value: 'shipping' },
  { title: '待退款', value: 'cancelapply' },
  { title: '待自取', value: 'ziti' },
  { title: '已取消', value: 'cancel' },
  { title: '已完成', value: 'finish' }
]

export const IN_PURCHASE_STATUS = [
  { title: '全部', value: '' },
  { title: '待付款', value: 'notpay' },
  { title: '待出貨', value: 'notship' },
  { title: '待收貨', value: 'shipping' },
  { title: '待退款', value: 'cancelapply' },
  { title: '已取消', value: 'cancel' },
  { title: '已完成', value: 'finish' }
  // { title: '配送中', value: 'dada_3' }
]

export const ORDER_TYPE = [
  { title: '全部', value: '' },
  { title: '團購訂單', value: 'groups' },
  { title: '秒殺訂單', value: 'seckill' },
  { title: '普通訂單', value: 'normal' },
  { title: '團購核銷訂單', value: 'multi_buy' },
  { title: '社區團購訂單', value: 'community' }
  // { title: "導購訂單", value: "shopguide" },
  // { title: "跨境訂單", value: "crossborder" },
  // { title: "助力訂單", value: "bargain" },
  // { title: "服務類訂單", value: "services" },
  // { title: "兌換訂單", value: "excard"}
]

export const ORDER_TYPE_STANDARD = [
  { title: '全部', value: '' },
  { title: '團購訂單', value: 'groups' },
  { title: '秒殺訂單', value: 'seckill' },
  { title: '普通訂單', value: 'normal' },
  { title: '團購核銷訂單', value: 'multi_buy' },
  { title: '社區團購訂單', value: 'community' },
  { title: '兌換訂單', value: 'excard' },
  { title: '門店訂單', value: 'shopadmin' }
]

export const INVOICE_STATUS = [
  { title: '全部', value: '' },
  { title: '未開票', value: 0 },
  { title: '已開票', value: 1 }
]

export const ORDER_CATEGORY = [
  { title: '全部', value: '' },
  { title: '自營訂單', value: 'self' },
  { title: '商家訂單', value: 'shop' }
]

export const REFUND_STATUS = {
  READY: '待審核',
  AUDIT_SUCCESS: '審核成功待退款',
  SUCCESS: '退款成功',
  SHOP_CHECK_FAILS: '商家審核不通過',
  CANCEL: '撤銷退款',
  PROCESSING: '已發起退款等待到帳',
  FAILS: '退款失敗',
  WAIT_CHECK: '待審核',
  WAIT_REFUND: '等待退款'
}

export const REFUND_PROCESS = {
  0: '待處理',
  1: '已取消',
  2: '退款中',
  3: '已完成',
  4: '已駁回'
}

export const PROFIT_TYPE = {
  1: '總部分潤',
  2: '自營門店分潤',
  3: '加盟門店分潤'
}

export const PAY_TYPE = {
  wxpay: '微信支付',
  amorepay: '微信支付',
  wechat: '微信支付',
  wepayjs: '微信支付',
  wxpaypc: '微信PC支付',
  wxpayh5: '微信H5支付',
  alipay: '支付寶支付',
  alipayh5: '支付寶H5支付',
  deposit: '餘額支付',
  point: '積分支付',
  // pos: 'POS銀行卡支付',
  pos: '現金支付',
  wxpaypos: '微信掃碼支付',
  alipaypos: '支付寶掃碼支付',
  chinaums: '微信支付-銀聯',
  // pay_channel
  wx_lite: '微信支付',
  wx_pub: '微信H5支付',
  wx_qr: '微信PC支付',
  alipay_wap: '支付寶H5支付',
  alipay_qr: '支付寶PC支付',
  alipaymini: '支付寶小程序'
}

export const PAY_STATUS = {
  SUCCESS: '支付成功',
  REFUND: '轉入退款',
  CANCEL_CLOSED: '已取消',
  REFUND_SUCCESS: '退款成功',
  NOTPAY: '未付款',
  CLOSED: '已關閉',
  REVOKED: '已撤銷',
  PAYERROR: '支付失敗(其他原因，如銀行返回失敗)'
}

export const PICKER_DATE_OPTIONS = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近一個月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近三個月',
      onClick(picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

export const FORM_COMP = {
  INPUT: 1,
  NUMBER: 2,
  DATE: 3,
  RADIO: 4,
  CHECKBOX: 5,
  MOBILE: 6,
  IMAGE: 7
}

export const SYSTEM_CONFIG = {
  platform: { name: '智管家商城', theme: '#CB060F' },
  standard: { name: '智管家商城', theme: '#FF9D00' },
  b2c: { name: '智管家商城', theme: '#157FE3' },
  in_purchase: { name: '智管家商城', theme: '#EC442E' }
}

export const LINK_PATH = {
  'goods': '商品',
  'store': '店鋪',
  'sale_category': '銷售分類',
  'category': '管理分類',
  'tag': '商品標籤',
  'article': '文章',
  'planting': '軟文',
  'link': '頁面',
  'marketing': '營銷',
  'regactivity': '活動報名',
  'seckill': '秒殺',
  'custom_page': '自定義頁面',
  'liverooms': '直播',
  'other_wxapp': '外部小程序'
}

export const CARD_TYPE = {
  'discount': '折扣券',
  'cash': '滿減券',
  'new_gift': '兌換券'
}

export const SECKILL_ACTIVITY_STATUS = {
  'waiting': '待開始',
  'in_the_notice': '預熱中',
  'in_sale': '進行中',
  'it_has_ended': '已結束'
}
